import { useEffect } from 'react';

// Pre-defined URL sets for regional invoice generator pages
export const INVOICE_GENERATOR_HREFLANG = {
  de: 'https://ivoliq.io/rechnungsvorlage-freelancer-deutschland',
  at: 'https://ivoliq.io/rechnungsvorlage-freelancer-oesterreich',
  ch: 'https://ivoliq.io/rechnungsvorlage-freelancer-schweiz',
  xDefault: 'https://ivoliq.io/rechnungsvorlage-freelancer',
};

// Tax rates by country
export const TAX_RATES = {
  DE: [
    { value: 0, label: '0% (Steuerbefreit)' },
    { value: 7, label: '7% (Ermäßigt)' },
    { value: 19, label: '19% (Standard)' },
  ],
  AT: [
    { value: 0, label: '0% (Steuerbefreit)' },
    { value: 10, label: '10% (Ermäßigt)' },
    { value: 13, label: '13% (Ermäßigt)' },
    { value: 20, label: '20% (Standard)' },
  ],
  CH: [
    { value: 0, label: '0% (Steuerbefreit)' },
    { value: 2.6, label: '2.6% (Ermäßigt)' },
    { value: 3.8, label: '3.8% (Sondersatz Beherbergung)' },
    { value: 8.1, label: '8.1% (Standard)' },
  ],
};

// Default tax rate by country
export const DEFAULT_TAX_RATE = {
  DE: 19,
  AT: 20,
  CH: 8.1,
};

// Currency by country
export const CURRENCY = {
  DE: { symbol: '€', code: 'EUR', locale: 'de-DE' },
  AT: { symbol: '€', code: 'EUR', locale: 'de-AT' },
  CH: { symbol: 'CHF', code: 'CHF', locale: 'de-CH' },
};

// Kleinunternehmer text by country
// MUST match backend statements.py 1:1 (Compliance — User-Auftrag Feb 2026)
export const KLEINUNTERNEHMER_TEXT = {
  DE: 'Gemäß § 19 UStG wird keine Umsatzsteuer berechnet.',
  AT: 'Umsatzsteuerbefreit gemäß § 6 Abs. 1 Z 27 UStG 1994.',
  CH: 'Von der Mehrwertsteuer befreit.',
};

// Tax ID labels by country
export const TAX_ID_LABELS = {
  DE: {
    vatId: 'USt-IdNr.',
    vatIdPlaceholder: 'DE123456789',
    vatIdPattern: /^DE[0-9]{9}$/,
    taxNumber: 'Steuernummer',
    taxNumberPlaceholder: '12/345/67890',
  },
  AT: {
    vatId: 'UID-Nummer',
    vatIdPlaceholder: 'ATU12345678',
    vatIdPattern: /^ATU[0-9]{8}$/,
    taxNumber: null, // Not used in AT
  },
  CH: {
    vatId: 'MWST-Nr.',
    vatIdPlaceholder: 'CHE-123.456.789 MWST',
    vatIdPattern: /^CHE-[0-9]{3}\.[0-9]{3}\.[0-9]{3}\s?MWST$/i,
    companyId: 'CHE-Nummer',
    companyIdPlaceholder: 'CHE-123.456.789',
  },
};

// Units
export const UNITS = [
  { value: 'Stück', label: 'Stück' },
  { value: 'Stunde', label: 'Stunde(n)' },
  { value: 'Tag', label: 'Tag(e)' },
  { value: 'Pauschal', label: 'Pauschal' },
  { value: 'Monat', label: 'Monat(e)' },
  { value: 'km', label: 'Kilometer' },
];

// Format currency
export const formatCurrency = (amount, country = 'DE') => {
  const { locale, code } = CURRENCY[country] || CURRENCY.DE;
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: code,
  }).format(amount);
};

// Format number
export const formatNumber = (num, country = 'DE') => {
  const { locale } = CURRENCY[country] || CURRENCY.DE;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
};

// Local storage keys
export const STORAGE_KEYS = {
  SENDER_DATA: 'ivoliq_invoice_sender',
};

// Save sender data to localStorage
export const saveSenderData = (data) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SENDER_DATA, JSON.stringify(data));
  } catch (e) {
    console.warn('Could not save to localStorage:', e);
  }
};

// Load sender data from localStorage
export const loadSenderData = () => {
  try {
    const data = localStorage.getItem(STORAGE_KEYS.SENDER_DATA);
    return data ? JSON.parse(data) : null;
  } catch (e) {
    console.warn('Could not load from localStorage:', e);
    return null;
  }
};
